var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SUPPORT_MODAL_TYPES } from './models';
import { Button, Modal } from '@appspotr/ui-kit';
import { ModalContentWrapper, ModalFooterButtonWrapper, ModalFooterWrapper, ModalText, } from './styles';
import { useContactSupportModalSchema } from './helpers';
import { Spacer } from 'components/base';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
export var ContactSupportModal = function (_a) {
    var isOpen = _a.isOpen, closeModal = _a.closeModal, supportType = _a.supportType, orgId = _a.orgId;
    var schema = useContactSupportModalSchema(supportType, { orgId: orgId });
    var footerButtonActions = function () {
        if (supportType === SUPPORT_MODAL_TYPES.DEV_PLAN) {
            return {
                primary: function () {
                    return (window.location.href = "mailto:support@appspotr.com?subject=".concat(orgId ? 'Developer Plan Issue in ' + orgId : 'Developer Plan Issue'));
                },
                secondary: closeModal,
            };
        }
        return {
            primary: function () { return closeModal(); },
            secondary: function () { return undefined; },
        };
    };
    var renderModalFooter = function () {
        switch (supportType) {
            case SUPPORT_MODAL_TYPES.DEV_PLAN:
                return (_jsx(ModalFooterWrapper, { children: _jsxs(ModalFooterButtonWrapper, { children: [(schema === null || schema === void 0 ? void 0 : schema.secondaryButtonText) && (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ type: "neutral", onClick: function () { return footerButtonActions().secondary(); } }, { children: schema.secondaryButtonText })), _jsx(Spacer, { type: "narrow" })] })), _jsx(Button, __assign({ onClick: function () { return footerButtonActions().primary(); }, iconLeft: faEnvelope }, { children: schema.primaryButtonText }))] }) }));
            default:
                return _jsx(_Fragment, {});
        }
    };
    return (_jsx(Modal, __assign({ isOpen: isOpen, closeModal: closeModal, title: schema.title, footer: renderModalFooter(), size: "sm" }, { children: _jsx(ModalContentWrapper, { children: _jsx(ModalText, { center: schema === null || schema === void 0 ? void 0 : schema.isContentCentered, dangerouslySetInnerHTML: { __html: schema.description } }) }) })));
};
